module.exports = __webpack_public_path__ + "static/media/rsz_img_1602_copy-min.2670d0f5.png";